import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type WeightUnit = 'kg' | 'lb';

export const WEIGHT_UNIT_NAMES = {
  kg: 'Kilogram (kg)',
  lb: 'Pound (lb)',
};

export const KG_TO_LB = 2.20462;
export const LB_TO_KG = 0.453592;
export const TON_TO_LB = 2204.62;
export const LB_TO_TON = 0.000453592;

interface UnitState {
  weightUnit: WeightUnit;
  setWeightUnit: (unit: WeightUnit) => void;
  convertWeight: (value: number, from: WeightUnit, to: WeightUnit) => number;
}

export const useUnitStore = create<UnitState>()(
  persist(
    (set) => ({
      weightUnit: 'kg',
      setWeightUnit: (unit) => set({ weightUnit: unit }),
      convertWeight: (value: number, from: WeightUnit, to: WeightUnit) => {
        if (from === to) return value;
        if (from === 'kg' && to === 'lb') return value * KG_TO_LB;
        if (from === 'lb' && to === 'kg') return value * LB_TO_KG;
        return value;
      },
    }),
    {
      name: 'broiler-unit-storage',
    }
  )
);
